import FormValidator from '../entities/FormValidator';
import {
  EMAIL_FORMAT_ERROR_MESSAGE,
  EMAIL_REGEX,
  PHONE_FORMAT_ERROR_MESSAGE,
  PHONE_REGEXP,
  REQUIRED_ERROR_MESSAGE,
  TIME_REGEXP,
  TIME_FORMAT_ERROR_MESSAGE,
  URL_REGEXP,
  URL_FORMAT_ERROR_MESSAGE,
  CASE_INSENSITIVE_EMAIL_REGEX,
  FILE_IS_TOO_BIG,
} from './constants';
import { FormCommonValidatorName } from './enums';

export const emailFormValidator = new FormValidator(
  (value) => {
    if (!value) {
      return true;
    }

    return EMAIL_REGEX.test(value);
  },
  EMAIL_FORMAT_ERROR_MESSAGE,
  FormCommonValidatorName.Email,
);

export const requiredFormValidator = new FormValidator(
  (value) => {
    if (!value) {
      return typeof value === 'number';
    }

    if (Array.isArray(value)) {
      return value.length;
    }

    return !!value;
  },
  REQUIRED_ERROR_MESSAGE,
  FormCommonValidatorName.Required,
);

export const phoneFormValidator = new FormValidator(
  (value) => {
    if (!value) {
      return true;
    }

    return PHONE_REGEXP.test(value);
  },
  PHONE_FORMAT_ERROR_MESSAGE,
  FormCommonValidatorName.Phone,
);

export const timeFormValidator = new FormValidator(
  (value) => TIME_REGEXP.test(value),
  TIME_FORMAT_ERROR_MESSAGE,
  FormCommonValidatorName.Time,
);

export const urlFormValidator = new FormValidator(
  (value) => {
    if (!value) {
      return true;
    }

    return URL_REGEXP.test(value);
  },
  URL_FORMAT_ERROR_MESSAGE,
  FormCommonValidatorName.Url,
);

export const getMinLengthFormValidator = (minLength, message) => new FormValidator(
  (value) => {
    if (!value) {
      return true;
    }

    if (typeof value === 'number') {
      return value?.toString().length >= minLength;
    }

    return value?.length >= minLength;
  },
  message,
  FormCommonValidatorName.MinLength,
);

export const getMaxLengthFormValidator = (maxLength, message) => new FormValidator(
  (value) => {
    if (!value) {
      return true;
    }

    if (typeof value === 'number') {
      return value?.toString().length <= maxLength;
    }

    return value?.length <= maxLength;
  },
  message,
  FormCommonValidatorName.MaxLength,
);

export const getMaxFormValidator = (max, message) => new FormValidator(
  (value) => {
    if (!value && value !== 0) {
      return true;
    }

    return Number(value) <= max;
  },
  message,
  FormCommonValidatorName.Max,
);

export const getMinFormValidator = (min, message) => new FormValidator(
  (value) => {
    if (!value && value !== 0) {
      return true;
    }

    return Number(value) >= min;
  },
  message,
  FormCommonValidatorName.Min,
);

export const caseInsensitiveEmailFormValidator = new FormValidator(
  (value) => {
    if (!value) {
      return true;
    }

    return CASE_INSENSITIVE_EMAIL_REGEX.test(value);
  },
  EMAIL_FORMAT_ERROR_MESSAGE,
  FormCommonValidatorName.Email,
);

export const createFileSizeValidator = (size) => new FormValidator(
  (value) => !value || value.size < size,
  FILE_IS_TOO_BIG,
  FormCommonValidatorName.FileSize,
);

export default {
  requiredFormValidator,
  emailFormValidator,
  phoneFormValidator,
  timeFormValidator,
  caseInsensitiveEmailFormValidator,
  getMinLengthFormValidator,
  getMaxLengthFormValidator,
  getMinFormValidator,
  getMaxFormValidator,
};
